import type { FaireProductEntity } from "../../entity_types/product";

export const p_jwxwsdg2wp: FaireProductEntity = {
  token: "p_jwxwsdg2wp",
  type: "product",
  name: "Chocolate Cheesecake Fudge Made with Cream Cheese extract",
  brandToken: "b_hxncymjum6",
  brandName: "Phenomenal Fudge",
  imageUrl:
    "https://cdn.faire.com/fastly/93eb437a3cb281e0199a9effc811090d7e0b07a52ddf60d95d4a906a49d4dc4d.jpeg",
  galleryImageUrls: [],
  priceDollars: 7.58,
  description:
    "Chocolate Cheesecake Fudge is not a cake but it sure is cheesy. The cream cheese flavor is mixed with 20% chocolate for a smooth texture along with the cheesey taste that is unforgettably great. FREE SHIPPING on all orders over $55. \n\nConsider sending a Gold Gift Tin of chocolate cheesecake fudge with our gift card.\n\nCream cheese based fudge in a 1/2 pound resealable tub. \n",
  tags: [],
  msrpDollars: 15.17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:46.253Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
